import {useTooltipTrigger} from '@react-aria/tooltip';
import {useTooltipTriggerState} from '@react-stately/tooltip';
import {memo, useRef} from 'react';

import {useIntl} from 'react-intl';

import {Tooltip, TooltipTextPrimary} from 'packages/ui-kit';

import styles from './rhs_header_channel_button.module.css';

type Props = {
    channelName: string;
    onClick: () => void;
}

const TOOLTIP_TRIGGER_STATE_PROPS = {};
const TOOLTIP_TRIGGER_PROPS = {};

const RhsHeaderChannelButton: React.FC<Props> = ({channelName, onClick: handleClick}) => {
    const {formatMessage} = useIntl();

    const triggerRef = useRef<HTMLButtonElement>(null);

    const tooltipTriggerState = useTooltipTriggerState(TOOLTIP_TRIGGER_STATE_PROPS);
    const {triggerProps, tooltipProps} = useTooltipTrigger(TOOLTIP_TRIGGER_PROPS, tooltipTriggerState, triggerRef);

    return (
        <>
            <button
                {...triggerProps}
                ref={triggerRef}
                onClick={handleClick}
                className='style--none sidebar--right__title__channel'
            >
                {channelName}
            </button>
            {tooltipTriggerState.isOpen && (
                <Tooltip
                    {...tooltipProps}
                    className={styles.tooltip}
                    targetRef={triggerRef}
                    state={tooltipTriggerState}
                >
                    <TooltipTextPrimary>{formatMessage({
                        id: 'channel_info_rhs.header.moveToChannel',
                        defaultMessage: 'Move to channel {channelName}',
                    }, {channelName})}</TooltipTextPrimary>
                </Tooltip>
            )}
        </>
    );
};

export default memo(RhsHeaderChannelButton);
